import { DOWNLOADS_MONTH_OPTIONS } from '../../config/settings/constants'

export const getListMonth = () => {
  return [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ]
}
export const getMonth = () => {
  return new Date().getMonth()
}

export const getMonthOptions = () => {
  return DOWNLOADS_MONTH_OPTIONS
}
